<div class="row">
  <div class="col-12 col-md-12">
    <section>
      <div class="row">
        <form [formGroup]="formPhysicalInventoryDetail">
          <div class="container-style mb-2">
            <div class="row">
              <div class="col field-code-article">
                <app-custom-input-number formControlName="articleCode" [labelText]="'Artículo'" [recovery]="true"
                  (onChangeNumber)="changeArticle($event)"></app-custom-input-number>
              </div>
              <div class="col field-article">
                <app-custom-input-text [labelText]="'Nombre Artículo'" [value]="codeNameArticle"
                  [disabled]="true"></app-custom-input-text>
              </div>
              <div class="col field-decimal">
                <app-custom-input-decimal formControlName="initialUnitCost"
                  [labelText]="'Cto.Uni'"></app-custom-input-decimal>
              </div>
              <div class="col field-number" [hidden]="hiddenCount1">
                <app-custom-input-decimal formControlName="physicalQuantity1" [labelText]="'Q.Física1'"
                  (onChangeNumber)="send()"></app-custom-input-decimal>
              </div>
              <div class="col field-number" [hidden]="hiddenCount2">
                <app-custom-input-decimal formControlName="physicalQuantity2" [labelText]="'Q.Física2'"
                  (onChangeNumber)="send()"></app-custom-input-decimal>
              </div>
              <div class="col field-number" [hidden]="hiddenCount3">
                <app-custom-input-decimal formControlName="physicalQuantity3" [labelText]="'Q.Física3'"
                  (onChangeNumber)="send()"></app-custom-input-decimal>
              </div>
              <div class="col field-number" [hidden]="hiddenCountFinal">
                <app-custom-input-decimal formControlName="physicalQuantityFinal" [labelText]="'Q.Final'"
                  (onChangeNumber)="send()"></app-custom-input-decimal>
              </div>
              <div class="col field-number">
                <app-custom-input-number formControlName="cardNumber" [labelText]="'Tarjeta'"></app-custom-input-number>
              </div>
              <div class="col field-observation">
                <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
                  [autoResize]="false"></app-custom-textarea>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
    <section class="container-style mb-2">
      <div id="header-detail" class="d-flex flex-row justify-content-between"></div>
      <div class="pt-1">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 ">
          <app-custom-table [headers]="header" [data]="countData" [actions]="tableActions"
            (onPageChange)="onPageChange($event)" (onRecoverData)="getAllArticleCountModalWithPagination()"
            (onAction)="onAction($event)"></app-custom-table>
        </div>
      </div>
    </section>
    <section>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
          <app-custom-button [title]="'Salir'" [label]="'Salir'" [severity]="'danger'"
            (onClick)="close()"></app-custom-button>
        </div>
      </div>
    </section>
  </div>
</div>